import React, { useEffect } from "react";
import { generateSlug } from "../../../../helpers/common";
import Loading from "../../../../components/Loading";
import styles from './Projects.module.scss'
import commonStyles from '../common.module.scss'
import { useRouter } from "next/router";
import Link from "next/link";
import Button from "../../../../components/ripple/Button";
import {
    CUSTOM_STACK_NAME,
    NAV_PROJECT_BUILDER_NAME,
    NAV_PROJECT_BUILDER_URL, NAV_PROJECT_COMPOSE_NAME, NAV_PROJECT_COMPOSE_URL,
    NAV_PROJECT_DEPLOYMENT_NAME,
    NAV_PROJECT_DEPLOYMENT_URL,
    NAV_PROJECT_DEPLOYMENTS_NAME,
    NAV_PROJECT_DEPLOYMENTS_URL
} from "../../../../settings/content/deploymentStacker";
import FoldingContent from "../../../../components/folding/FoldingContent";
import { NAV_STACK_LIST } from "../../../../settings/navigation";

function getAge(date) {

    const parsedCurrentTime = new Date();

    if (!!date) {
        // database time is written in ISO UTC (+0200), so ignore local user time
        const updatedUTC = new Date(date);
        const difference = parsedCurrentTime.getTime() - updatedUTC.getTime();
        let differenceInDays = difference / (1000 * 3600 * 24);

        if (differenceInDays <= 7) return 'week';
        if (differenceInDays > 7 && differenceInDays <= 30) return 'month';
    }

    return 'old'
}

function ProjectItemLayout({current, href, onClick, onProjectDelete, disabled, project, children, ...props}) {

    const itemHeader = (
        <div className={styles.project__head}>
            <p className={styles.project__head__title}>{project.body?.custom?.project_name || 'New project'}</p>
            <Button
                className={styles.project__head__delete}
                icon='far fa-trash-alt'
                displayType='text'
                onClick={e => {
                    e.stopPropagation();
                    e.preventDefault();
                    if (confirm('Are you sure?')) onProjectDelete(project.id);
                }}
                disabled={disabled}
            />
        </div>
    );

    return current
        ? <div {...props}>{itemHeader}{children}</div>
        : <Link href={href} onClick={onClick} {...props}>{itemHeader}</Link>
}

export default function Projects({
                                     modified,
                                     compose,
                                     projects,
                                     projectsStatus,
                                     onProjectCreate,
                                     onProjectDelete,
                                     cloudConnected,
                                 }) {

    const router = useRouter();

    useEffect(() => {
        if (projectsStatus === 'success' && !!router.query.project) {
            setTimeout(() => document.getElementById('builder-current-project')?.scrollIntoView(), 100);
        }
    }, [projectsStatus, router]);

    const renderProjects = _projects => {
        return _projects.map((p, i) => {

            const current = p.id + '' === router.query.project;
            const disabled = projectsStatus !== 'success';
            const currentStyle = current ? ' ' + styles['project--current'] : '';
            const disabledStyle = disabled ? ' ' + styles['project--disabled'] : '';

            const links = [
                {url: NAV_PROJECT_BUILDER_URL, name: NAV_PROJECT_BUILDER_NAME, icon: 'fas fa-cog',},
                {
                    url: NAV_PROJECT_DEPLOYMENT_URL,
                    name: NAV_PROJECT_DEPLOYMENT_NAME,
                    disabled: modified || projectsStatus !== 'success' || !compose,
                    icon: 'fas fa-cloud',
                },
                {
                    url: NAV_PROJECT_COMPOSE_URL,
                    name: NAV_PROJECT_COMPOSE_NAME,
                    disabled: !compose || modified || projectsStatus !== 'success' || !cloudConnected,
                    icon: 'fas fa-file-alt',
                },
                {url: NAV_PROJECT_DEPLOYMENTS_URL, name: NAV_PROJECT_DEPLOYMENTS_NAME, icon: 'fas fa-list',},
            ];

            // return (
            //     <Link
            //         id={current ? 'builder-current-project' : undefined}
            //         className={`${styles.project}${currentStyle}${disabledStyle}`}
            //         onClick={
            //             (disabled || modified)
            //                 ? e => {
            //                     if (modified) {
            //                         if (!confirm('All unsaved changes will be lost. Are you sure?')) {
            //                             e.preventDefault();
            //                         }
            //                     } else {
            //                         e.preventDefault();
            //                     }
            //                 }
            //                 : undefined
            //         }
            //         href={`${NAV_STACK_LIST}/${generateSlug(CUSTOM_STACK_NAME)}/builder?project=${p.id}&section=${links[0].url}`}
            //         key={i}
            //     >
            //
            //     </Link>
            // );

            const itemProps = {
                id: current ? 'builder-current-project' : undefined,
                className: `${styles.project}${currentStyle}${disabledStyle}`,
                onClick: (disabled || modified)
                    ? e => {
                        if (modified) {
                            if (!confirm('All unsaved changes will be lost. Are you sure?')) e.preventDefault();
                        } else {
                            e.preventDefault();
                        }
                    }
                    : undefined,
                href: `${NAV_STACK_LIST}/${generateSlug(CUSTOM_STACK_NAME)}/builder?project=${p.id}&section=${links[0].url}`,
            }

            return (
                <ProjectItemLayout
                    current={current}
                    onProjectDelete={onProjectDelete}
                    disabled={disabled}
                    project={p}
                    key={i}
                    {...itemProps}
                >
                    <FoldingContent folded={!current}>
                        <div className={styles.project__nav}>
                            {
                                links.map((link, index) => {

                                    const disabled = link.disabled || projectsStatus === 'loading';
                                    const current = router.query?.section === link.url || !router.query?.section && index === 0;
                                    const isCurrent = current ? ' ' + styles['section--current'] : '';
                                    const isDisabled = disabled ? ' ' + styles['section--disabled'] : '';
                                    const url = `${NAV_STACK_LIST}/${generateSlug(CUSTOM_STACK_NAME)}/builder?project=${p.id}&section=`;

                                    return (
                                        <Link
                                            className={`${styles.section}${isCurrent}${isDisabled}`}
                                            onClick={
                                                (disabled || modified)
                                                    ? e => {
                                                        if (modified) {
                                                            if (!confirm('All unsaved changes will be lost. Are you sure?')) e.preventDefault();
                                                        } else {
                                                            e.preventDefault();
                                                        }
                                                    }
                                                    : undefined
                                            }
                                            href={disabled ? '' : `${url}${link.url}`} key={index + link.url}
                                            draggable='false'
                                            tabIndex={disabled ? -1 : 0}
                                        >
                                            <i className={`${link.icon} ${styles.section__icon}`}/>
                                            <p className={styles.section__text}>{link.name}</p>
                                        </Link>
                                    );
                                })
                            }
                        </div>
                    </FoldingContent>
                </ProjectItemLayout>
            )
        });
    }

    const renderBlock = (title, _projects) => {
        return (
            <div className={styles.nav__block}>
                <p className={styles.nav__block__title}>{title}</p>
                <div className={styles.nav__block__items}>{renderProjects(_projects)}</div>
            </div>
        )
    }

    const week = projects.filter(p => getAge(p.updated_at) === 'week');
    const fresh = projects.filter(p => getAge(p.updated_at) === 'month');
    const old = projects.filter(p => getAge(p.updated_at) === 'old');

    return (
        <nav className={styles.nav}>
            <div className={styles.new}>
                <Button
                    className={styles.new__button}
                    title='Create new project'
                    iconLeft='far fa-file'
                    onClick={() => onProjectCreate()}
                    visuals={{
                        colorBasic: ['var(--colorAccentSoft)'],
                        colorFont: ['var(--colorAccentBasic)']
                    }}
                />
            </div>
            <div className={styles.nav__content}>
                {
                    projectsStatus === 'loading' &&
                    <Loading
                        className={!projects.length ? commonStyles.loading : styles.loading}
                        icon={{faCode: 'fas fa-chevron-down', animationType: 'bottom'}}
                        message={!projects.length ? 'Getting projects...' : undefined}
                        type={!projects.length ? 'component' : 'component-cover'}
                        coverOpacity={0}
                    />
                }
                {!!week.length && renderBlock('This week', week)}
                {!!fresh.length && renderBlock('This month', fresh)}
                {!!old.length && renderBlock('Older', old)}
                {
                    !projects.length && projectsStatus === 'success' &&
                    <p className={styles.nav__empty}>Your projects will appear here</p>
                }
                {
                    projectsStatus === 'error' &&
                    <div className={styles.error}>
                        <i className={`fas fa-exclamation-triangle ${styles.error__icon}`}/>
                        <p className={styles.error__message}>
                            Couldn't load your projects.
                        </p>
                        <Button
                            title='Contact support'
                            iconRight='fas fa-headset'
                            visuals={{colorBasic: ['var(--colorFontError)']}}
                        />
                    </div>
                }
            </div>
        </nav>
    )
}